import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'attendantsfilter'
})
export class AttendantsFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value || !args) {
      return value;
    }

    return value.filter(item => item.isGuest === args);
  }

}
